import type { MouseEvent } from "react";

import { callAll } from "../../../utils/call-all";
import { useScrollBarContext } from "../scroll-bar.context";
import styles from "../scroll-bar.module.scss";
import type { ScrollBarCaretProps } from "../types-scroll-bar";

/** Triângulo `CaretDownSolid8` do Figma (9795:5642); as outras direções giram o mesmo desenho. */
const CARET_PATH =
  "M3 6C3 5.86458 3.02604 5.73568 3.07812 5.61328C3.13021 5.49089 3.20052 5.38542 3.28906 5.29688C3.38021 5.20573 3.48568 5.13411 3.60547 5.08203C3.72526 5.02734 3.85417 5 3.99219 5H10.0117C10.1471 5 10.2747 5.02604 10.3945 5.07812C10.5169 5.13021 10.6224 5.20182 10.7109 5.29297C10.7995 5.38411 10.8698 5.49089 10.9219 5.61328C10.974 5.73307 11 5.86068 11 5.99609C11 6.10547 10.9844 6.20573 10.9531 6.29688C10.9245 6.38802 10.8802 6.47917 10.8203 6.57031L8.21875 10.3555C8.08073 10.556 7.90365 10.7135 7.6875 10.8281C7.47396 10.9427 7.24479 11 7 11C6.75521 11 6.52474 10.9427 6.30859 10.8281C6.09505 10.7135 5.91927 10.556 5.78125 10.3555L3.17969 6.57031C3.11979 6.48177 3.07422 6.39193 3.04297 6.30078C3.01432 6.20964 3 6.10938 3 6Z";

export function ScrollBarCaret({ direction, className, onClick, ...rest }: ScrollBarCaretProps) {
  const { stepTo, partTestId } = useScrollBarContext();

  return (
    <button
      type="button"
      tabIndex={-1}
      aria-hidden="true"
      className={[styles.caret, className].filter(Boolean).join(" ")}
      data-direction={direction}
      data-testid={partTestId("caret", direction)}
      {...rest}
      onClick={callAll<[MouseEvent<HTMLButtonElement>]>(() => stepTo(direction), onClick)}
    >
      <svg viewBox="3 5 8 6" className={styles.glyph} focusable="false" aria-hidden="true">
        <path d={CARET_PATH} fill="currentColor" />
      </svg>
    </button>
  );
}
ScrollBarCaret.displayName = "ScrollBar.Caret";
